/*
==================================================
CART MOBILE POINTS

Функция:
блок кнопки баллов в верхней зоне мобильной модалки

Родитель:
index.tsx

Дочерние элементы:
нет

Использует:
пока без visual config / animation config / controller

Примечания:
сейчас это визуальная заглушка без бизнес-логики
==================================================
*/

import { triggerHaptic } from "../../../../lib/custom-ui/haptics/haptics"

type CartMobilePointsProps = {
  points?: number | string
  onClick?: () => void
}

export default function CartMobilePoints({
  points = 0,
  onClick,
}: CartMobilePointsProps) {
  return (
    <button
      type="button"
      onClick={() => {
        triggerHaptic(10)
        onClick?.()
      }}
      className="flex h-11 flex-[1.32] items-center gap-2.5 rounded-xl border border-white/25 px-3.5 text-white shadow-lg backdrop-blur-md transition-all active:scale-95"
      style={{
        background:
          "linear-gradient(90deg, #17365b 0%, #245b93 48%, #3794e6 100%)",
      }}
    >
      <span
        className="text-[17px]"
        style={{
          filter: "drop-shadow(0 0 6px rgba(255,255,255,0.45))",
        }}
      >
        ✦
      </span>

      <span className="flex-1 text-left text-[15px] font-bold">
        Your points
      </span>

      <span
        className="flex h-8 min-w-[64px] items-center justify-center rounded-lg border border-white/30 text-[15px] font-black"
        style={{
          background:
            "linear-gradient(180deg, #ff8229 50%, #eb6405 100%)",
        }}
      >
        {points}
      </span>
    </button>
  )
}
